
import React, { useEffect, useState, useRef, } from "react";
import {
    Row,
    Col,
    Form,
    Input, Textarea,
    Select,
    InputNumber,
    Button,
    Switch,
    useCRUDController,
    SpreadsheetEditor,
    Tabs,
    DynamicDataSelector,
    Radio
} from '../ui/ot'
import { Label } from "../ui/label"
import { transformResponses } from "./base_canvas_element_utils";

const SettingToolForm = ({
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {},
    element,
    componentType,
    five_w_id = null,
    documentFiveWAPI = "/utility/document",
    fiveWResponseAPI,
    dropDownDocumentAPiRoute,
    dropDownDocumentController,
    elementsData = []
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_;
    const [count, setCount] = useState(0);
    const [selectDocumentAndResponseData, setSelectDocumentAndResponseData] = useState([]) //記錄已選擇的文件及回應資料
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {
        let formValues = null;
        formValues = form.getFieldsValue();
        propsOnValuesChange(
            formValues
        )
        // 如果變動的是 filter_document_data 的 document_id，將這個值同步到
        // 所有 form_column_filter_data 內的 filter_document_data[].document_id
        if (name === "form_column_filter_data.0.filter_document_data.0.document_id") {
            let document_id = value?.['form_column_filter_data']?.[0]?.["filter_document_data"]?.[0]?.document_id
            try {
                const filterArr = form.getFieldValue('form_column_filter_data') || []
                if (Array.isArray(filterArr) && filterArr.length > 0) {
                    const newFilterArr = filterArr.map((filterItem) => {
                        const fdocs = Array.isArray(filterItem?.filter_document_data) ? filterItem.filter_document_data : []
                        const newFdocs = fdocs.map((fd) => ({ ...(fd || {}), document_id: document_id }))
                        return { ...(filterItem || {}), filter_document_data: newFdocs }
                    })
                    // write back to the form
                    form.setFieldValue('form_column_filter_data', newFilterArr)
                    const newFormValues = form.getFieldsValue()
                    propsOnValuesChange(newFormValues)
                }
            } catch (e) {
                console.error('sync filter_document_data.document_id failed', e)
            }
        }
    };

    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {

    }, [])
    useEffect(() => {

        return () => {
            form.submit()
        };
    }, [])

    const documentFiveWController = useCRUDController({ apiRoute: documentFiveWAPI })
    useEffect(() => {
        documentFiveWController.getData({
            five_w_id
        })
    }, []);

    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                form={form}
                                propsOnValuesChange={propsOnValuesChange}
                                componentType={componentType}
                                documentFiveWData={documentFiveWController?.ResponseData ?? []}
                                fiveWResponseAPI={fiveWResponseAPI}
                                dropDownDocumentController={dropDownDocumentController}
                                dropDownDocumentAPiRoute={dropDownDocumentAPiRoute}

                                selectDocumentAndResponseData={selectDocumentAndResponseData}
                                setSelectDocumentAndResponseData={setSelectDocumentAndResponseData}
                                elementsData={elementsData}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    form,
    propsOnValuesChange,
    componentType,
    documentFiveWData,
    fiveWResponseAPI,
    dropDownDocumentController: propsDocumentController,
    dropDownDocumentAPiRoute = '/utility/document/base_view', // /utility/document?dropdown=1
    setSelectDocumentAndResponseData = () => { },
    selectDocumentAndResponseData,
    elementsData = []
}) => {
    const [validationSelectionOptions, setValidationSelectionOptions] = useState([]);
    const documentController_ = useCRUDController({
        apiRoute: dropDownDocumentAPiRoute
    })
    const documentController = propsDocumentController ?? documentController_
    const addFormColumnSelectionOptionData = () => {
        let form_column_selection_option_data = form.getFieldValue([field?.name, 'form_column_selection_option_data'])
        form_column_selection_option_data.push({
            "selection_option_classify_structure_type_data": [
                {
                    "name_language_data": [
                        {
                            "language_culture_code": "zh-tw",
                            "language_culture_value": null
                        }
                    ]
                }
            ]
        })
        form.setFieldValue('form_column_selection_option_data', form_column_selection_option_data)
        let formValues = form.getFieldsValue()
        propsOnValuesChange(
            formValues
        )
    };
    const removeFormColumnSelectionOptionData = (index) => {
        let form_column_selection_option_data = form.getFieldValue([field?.name, 'form_column_selection_option_data'])
        form_column_selection_option_data = form_column_selection_option_data.filter((_, itemIndex) => itemIndex !== index)
        form.setFieldValue('form_column_selection_option_data', form_column_selection_option_data)
        let formValues = form.getFieldsValue()
        propsOnValuesChange(
            formValues
        )
    }
    const handleOnFormColumnSource = ({
        target: {
            name,
            value,
            checked
        }
    } = {}) => {
        if (name === 'form_column_source') {
            if (checked) {
                form.setFieldValue('form_column_source_data', [
                    {
                        form_column_source_id: undefined,
                        source_id: undefined,
                        document_source_data: [
                            {
                                document_source_id: undefined,
                                is_major: 1,

                            }
                        ]
                    }
                ])
                form.setFieldValue('form_column_selection_option_data', [])

            } else {

                form.setFieldValue('form_column_source_data', [])
                form.setFieldValue('form_column_selection_option_data', [])
            }
            return
        }
    }

    const validationSelectionController = useCRUDController({ apiRoute: "/utility/validation/selection" })
    const getCode = () => {
        let code = form.getFieldValue([field?.name, 'code'])
        return code
    }

    useEffect(() => {
        validationSelectionController.getData()
            .then((res) => {
                let data = res?.data;
                let firstData = data?.find(_ => true)
                let selection_selection_option_data = (firstData?.selection_selection_option_data || [])?.map(item => ({
                    label: item?.name,
                    value: item?.value
                }))
                setValidationSelectionOptions(selection_selection_option_data)

            })
    }, [])

    useEffect(() => {
        if (propsDocumentController === undefined) {
            documentController.getData()
        }
    }, [])
    return (
        <Row>
            {["bar_chart", "pie_chart", "line_chart", "table_chart"].includes(componentType) ? <>
                <Col span={24} >
                    <h5 className="font-medium text-gray-800">圖表設定</h5>
                </Col>
                <Col span={24} >
                    <Form.Item
                        labelCol={24}
                        wrapperCol={24}
                        label="顯示標籤文字"
                        name={[field?.name, "code"]}
                    >
                        <Input placeholder="例如：姓名、電話、地址..." />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name={[field?.name, "form_column_source"]}
                    >
                        <Switch
                            checkedChildren={'動態資料'}
                            unCheckedChildren={'靜態資料'}
                            onChange={(e) => {
                                handleOnFormColumnSource(e)
                                form.setFieldValue('default_value', null)
                            }}
                        />
                    </Form.Item>
                </Col>
                {/* <Tabs
                    defaultActiveKey={form.getFieldValue([field?.name, 'form_column_source']) ? 'dynamic' : 'static'}
                    activeKey={form.getFieldValue([field?.name, 'form_column_source']) ? 'dynamic' : 'static'}
                    items={[
                        {
                            key: 'static',
                            tab: '靜態資料',
                        },
                        {
                            key: 'dynamic',
                            tab: '動態資料',
                        },
                    ]}
                    onChange={(value) => {
                        form.setFieldValue('form_column_source', value === 'dynamic' ? true : false)
                        handleOnFormColumnSource({
                            target: {
                                name: 'form_column_source',
                                value,
                                checked: value === 'dynamic' ? true : false
                            }
                        })
                    }}
                /> */}
                <Col span={24}>
                    {form.getFieldValue([field?.name, 'form_column_source']) ?
                        <>
                            <Col span={24}>
                                {form.getFieldValue([field?.name, 'form_column_source']) && <Row>
                                    <Col span={24}>
                                        <Form.List
                                            {...field}
                                            name={[field?.name, 'form_column_source_data']}
                                        >
                                            {(subfields, { add, remove }) => (
                                                <Row>
                                                    {subfields.map((subfield, subfieldIndex) => (
                                                        <Col span={24} key={subfield.key}>
                                                            <Row gutter={[0, 0]}>
                                                                <Col   >
                                                                    <Form.Item
                                                                        labelCol={24}
                                                                        wrapperCol={24}
                                                                        {...subfield}
                                                                        name={[subfield?.name ?? '', 'form_column_source_id']}
                                                                        fieldKey={[subfield?.fieldKey ?? '', 'form_column_source_id']}
                                                                        label="form_column_source_id"
                                                                        hidden={true}
                                                                    >
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col   >
                                                                    <Form.Item
                                                                        labelCol={24}
                                                                        wrapperCol={24}
                                                                        {...subfield}
                                                                        name={[subfield?.name ?? '', 'source_id']}
                                                                        fieldKey={[subfield?.fieldKey ?? '', 'source_id']}
                                                                        label="source_id"
                                                                        hidden={true}
                                                                    >
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={24} >
                                                                    <Form.List
                                                                        {...subfield}
                                                                        name={[subfield?.name ?? '', 'document_source_data']}
                                                                    >
                                                                        {(subsubfields, { add },) => (
                                                                            <Row>
                                                                                {subsubfields.map((subsubfield, subsubfieldsIndex) => (
                                                                                    <Col span={24} key={subsubfield?.key} >
                                                                                        <Form.Item
                                                                                            {...subsubfield}
                                                                                            labelCol={24}
                                                                                            wrapperCol={24}
                                                                                            name={[subsubfield?.name ?? '', 'docuemnt_source_id']}
                                                                                            label="docuemnt_source_id"
                                                                                            hidden={true}
                                                                                        >

                                                                                        </Form.Item>
                                                                                        <Form.Item
                                                                                            {...subsubfield}
                                                                                            labelCol={24}
                                                                                            wrapperCol={24}
                                                                                            name={[subsubfield?.name ?? '', 'is_major']}
                                                                                            label="is_major"
                                                                                            hidden={true}
                                                                                        >

                                                                                        </Form.Item>
                                                                                        <Form.Item
                                                                                            {...subsubfield}
                                                                                            labelCol={24}
                                                                                            wrapperCol={24}
                                                                                            name={[subsubfield?.name ?? '', 'document_id']}
                                                                                            label={'請選擇下拉式選單來源'}
                                                                                        >
                                                                                            <FiveWdocument
                                                                                                documentFiveWData={documentFiveWData}
                                                                                                fiveWResponseAPI={fiveWResponseAPI}
                                                                                                setSelectDocumentAndResponseData={setSelectDocumentAndResponseData}
                                                                                                selectDocumentAndResponseData={selectDocumentAndResponseData}
                                                                                            />
                                                                                        </Form.Item>
                                                                                    </Col>
                                                                                ))}
                                                                            </Row>
                                                                        )}
                                                                    </Form.List>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            )}
                                        </Form.List>
                                    </Col>

                                </Row>}
                            </Col>
                            {selectDocumentAndResponseData && <Col span={24} >
                                <Form.Item
                                    labelCol={24}
                                    wrapperCol={24}
                                    label=""
                                    name={[field?.name, "default_value"]}
                                >
                                    <ChartDataSetting
                                        selectDocumentAndResponseData={selectDocumentAndResponseData}
                                    />
                                </Form.Item>
                            </Col>}
                        </>
                        :
                        <>
                            <Col span={24} >
                                <Form.Item
                                    labelCol={24}
                                    wrapperCol={24}
                                    label=""
                                    name={[field?.name, "default_value"]}
                                >
                                    <SpreadsheetData key={"static"} />
                                </Form.Item>
                            </Col>
                        </>
                    }
                </Col>
            </> : <>
                <Col span={24} >
                    <Row>
                        <Col span={24} >
                            <h5 className="font-medium text-gray-800">基本設定</h5>
                        </Col>
                        {
                            ['名稱', '描述', '圖片'].includes(getCode()) &&
                            <Col span={24} >
                                系統預設欄位：{getCode()}
                            </Col>
                        }
                        {!['名稱', '描述', '圖片'].includes(getCode()) &&
                            <Col span={24} >
                                <Form.Item
                                    labelCol={24}
                                    wrapperCol={24}
                                    label="顯示標籤文字"
                                    name={[field?.name, "code"]}
                                >
                                    <Input placeholder="例如：姓名、電話、地址..." />
                                </Form.Item>
                            </Col>
                        }
                        {['名稱', '描述', '圖片'].includes(getCode()) &&
                            <Col span={24} >
                                <Form.Item
                                    labelCol={24}
                                    wrapperCol={24}
                                    label="顯示標籤文字"
                                    name={[field?.name, "alt"]}
                                >
                                    <Input placeholder="例如：姓名、電話、地址..." />
                                </Form.Item>
                            </Col>
                        }

                        <Col span={24} >
                            <Form.Item
                                labelCol={24}
                                wrapperCol={24}
                                label="必填欄位 "
                                name={[field?.name, "is_required"]}
                            >
                                <Switch mode="number" checkedChildren={"必填"} unCheckedChildren={"非必填"} />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={24}
                                wrapperCol={24}
                                label="不可編輯 "
                                name={[field?.name, "fill_disable"]}
                            >
                                <Switch mode="number" checkedChildren={"不可編輯"} unCheckedChildren={"可編輯"} />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={24}
                                wrapperCol={24}
                                label="前台隱藏 "
                                name={[field?.name, "fill_hidden"]}
                            >
                                <Switch mode="number" checkedChildren={"隱藏"} unCheckedChildren={"顯示"} />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <DefaultValueSelector
                                elementsData={elementsData}
                                form={form}
                                field={field}
                                documentOptions={documentController?.ResponseData?.map(item => (
                                    {
                                        label: item?.document_name,
                                        value: item?.document_id,
                                    }
                                ))}
                                documentData={documentController?.ResponseData}
                            />
                            {/* <Form.Item
                                labelCol={24}
                                wrapperCol={24}
                                label="預設值"
                                name={[field?.name, "default_value"]}
                            >

                            </Form.Item> */}
                        </Col>

                        <Col span={24} >
                            <Form.Item
                                labelCol={24}
                                wrapperCol={24}
                                label="提示文字"
                                name={[field?.name, "placeholder"]}
                            >
                                <Input placeholder="例如：請輸入您的姓名..." />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={24}
                                wrapperCol={24}
                                label="說明文字"
                                name={[field?.name, "help_text"]}
                            >
                                <Input placeholder="例如：此欄位將用於聯絡確認..." />
                            </Form.Item>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Row>
                        <Col span={24}>
                            <h5 className="font-medium text-gray-800">驗證規則 </h5>
                        </Col>
                        <Col span={24}>
                            <Form.List
                                {...field}
                                name={[field?.name, 'form_column_validation_data']}>
                                {(fields, { add, remove }) => <>
                                    {fields.map((field, index) => <>
                                        <Row gutter={[0, 0]}>
                                            <Col span={24}>
                                                <Form.Item
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    label="form_column_validation_id"
                                                    name={[field?.name, "form_column_validation_id"]}
                                                    hidden={true}
                                                >

                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    label="validation_id"
                                                    name={[field?.name, "validation_id"]}
                                                    hidden={true}
                                                >

                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    label="格式驗證"
                                                    name={[field?.name, "format"]}
                                                >
                                                    <Select
                                                        options={validationSelectionOptions}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    label="最少字數"
                                                    name={[field?.name, "min_text_number"]}
                                                >
                                                    <InputNumber min={0} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    label="最多字數"
                                                    name={[field?.name, "max_text_number"]}
                                                >
                                                    <InputNumber min={0} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    label="最小值"
                                                    name={[field?.name, "min_value"]}
                                                >
                                                    <InputNumber />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    label="最大值"
                                                    name={[field?.name, "max_value"]}
                                                >
                                                    <InputNumber />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                {/* 特殊字元限制 */}
                                                <div className="space-y-2">
                                                    <Label className="text-sm font-medium">字元限制</Label>
                                                    <div className="space-y-2">
                                                        <Form.Item
                                                            labelCol={12}
                                                            wrapperCol={12}
                                                            label="禁止特殊符號"
                                                            name={[field?.name, "disable_special_character"]}
                                                        >
                                                            <Switch mode="number" checkedChildren={"是"} unCheckedChildren={"否"} />
                                                        </Form.Item>
                                                        <Form.Item
                                                            labelCol={12}
                                                            wrapperCol={12}
                                                            label="僅允許中文"
                                                            name={[field?.name, "only_allow_chinese"]}
                                                        >
                                                            <Switch mode="number" checkedChildren={"是"} unCheckedChildren={"否"} />
                                                        </Form.Item>
                                                        <Form.Item
                                                            labelCol={12}
                                                            wrapperCol={12}
                                                            label="僅允許英文"
                                                            name={[field?.name, "only_allow_english"]}
                                                        >
                                                            <Switch mode="number" checkedChildren={"是"} unCheckedChildren={"否"} />
                                                        </Form.Item>
                                                        {/* <div className="flex items-center space-x-2">
                                                        <Checkbox id="no-numbers" />
                                                        <Label htmlFor="no-numbers" className="text-sm">
                                                            禁止數字
                                                        </Label>
                                                    </div> */}

                                                    </div>
                                                </div>

                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    label="錯誤訊息"
                                                    name={[field?.name, "wrong_message"]}
                                                >
                                                    <Input placeholder="例如：請輸入正確的電子郵件格式" />

                                                </Form.Item>
                                            </Col>


                                        </Row>
                                    </>)}
                                </>}
                            </Form.List>
                        </Col>
                        {
                            /**
                             * US19、US20、US21
                             * 需要增加欄位來源，並進行運算後變成新的欄位的值
                             */
                        }
                        <Col span={24} >
                            <h5 className="font-medium text-gray-800">選項設定 (Options)</h5>
                            <p className="text-xs text-gray-500">適用於下拉選單、單選按鈕、多選清單</p>
                        </Col>
                        {
                            /**
                             * US16
                             * 需要增加動態資料的分類
                             */
                        }
                        <Col span={24}>
                            <Form.Item
                                name={[field?.name, "form_column_source"]}
                            >
                                <Switch
                                    checkedChildren={'動態資料'}
                                    unCheckedChildren={'靜態資料'}
                                    onChange={handleOnFormColumnSource}
                                />
                            </Form.Item>
                        </Col>
                        {form.getFieldValue([field?.name, 'form_column_source']) && <>
                            <Col span={24}>
                                <Form.List
                                    {...field}
                                    name={[field?.name, 'form_column_source_data']}
                                >
                                    {(subfields, { add, remove }) => (
                                        <Row>
                                            {subfields.map((subfield, subfieldIndex) => (
                                                <Col span={24} key={subfield.key}>
                                                    <Row gutter={[0, 0]}>
                                                        <Col   >
                                                            <Form.Item
                                                                labelCol={24}
                                                                wrapperCol={24}
                                                                {...subfield}
                                                                name={[subfield?.name ?? '', 'form_column_source_id']}
                                                                fieldKey={[subfield?.fieldKey ?? '', 'form_column_source_id']}
                                                                label="form_column_source_id"
                                                                hidden={true}
                                                            >
                                                            </Form.Item>
                                                        </Col>
                                                        <Col   >
                                                            <Form.Item
                                                                labelCol={24}
                                                                wrapperCol={24}
                                                                {...subfield}
                                                                name={[subfield?.name ?? '', 'source_id']}
                                                                fieldKey={[subfield?.fieldKey ?? '', 'source_id']}
                                                                label="source_id"
                                                                hidden={true}
                                                            >
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={24} >
                                                            <Form.List
                                                                {...subfield}
                                                                name={[subfield?.name ?? '', 'document_source_data']}
                                                            >
                                                                {(subsubfields, { add },) => (
                                                                    <Row>
                                                                        {subsubfields.map((subsubfield, subsubfieldsIndex) => (
                                                                            <Col span={24} key={subsubfield?.key}  >
                                                                                <Form.Item
                                                                                    {...subsubfield}
                                                                                    labelCol={24}
                                                                                    wrapperCol={24}
                                                                                    name={[subsubfield?.name ?? '', 'docuemnt_source_id']}
                                                                                    label="docuemnt_source_id"
                                                                                    hidden={true}
                                                                                >

                                                                                </Form.Item>
                                                                                <Form.Item
                                                                                    {...subsubfield}
                                                                                    labelCol={24}
                                                                                    wrapperCol={24}
                                                                                    name={[subsubfield?.name ?? '', 'is_major']}
                                                                                    label="is_major"
                                                                                    hidden={true}
                                                                                >

                                                                                </Form.Item>
                                                                                <Form.Item
                                                                                    {...subsubfield}
                                                                                    labelCol={24}
                                                                                    wrapperCol={24}
                                                                                    name={[subsubfield?.name ?? '', 'document_id']}
                                                                                    label={'請選擇下拉式選單來源'}
                                                                                >
                                                                                    <Select
                                                                                        options={
                                                                                            documentController.ResponseData.map((doc) => {
                                                                                                let name_language_data = doc?.name_language_data || []
                                                                                                let name_language_data_zh_TW = name_language_data.find((n) => n.language_code === "zh-TW") || {}
                                                                                                let title = name_language_data_zh_TW?.language_culture_value || doc?.title || "無標題"
                                                                                                return {
                                                                                                    label: title,
                                                                                                    value: doc?.document_id
                                                                                                }
                                                                                            })
                                                                                        }
                                                                                    />
                                                                                </Form.Item>
                                                                            </Col>
                                                                        ))}
                                                                    </Row>
                                                                )}
                                                            </Form.List>
                                                        </Col>

                                                    </Row>
                                                </Col>
                                            ))}
                                        </Row>
                                    )}
                                </Form.List>
                            </Col>
                        </>}

                        {!form.getFieldValue([field?.name, 'form_column_source']) && <>
                            <Col span={24}>
                                <Form.List
                                    {...field}
                                    label={"選項列表"}
                                    name={[field?.name, 'form_column_selection_option_data']}
                                >
                                    {(subfields, { add, remove }) => (
                                        <Row>
                                            {subfields.map((subfield, subfieldIndex) => (
                                                <Col span={24} key={subfield.key}>
                                                    <Row gutter={[0, 0]}>
                                                        <Col   >
                                                            <Form.Item
                                                                labelCol={24}
                                                                wrapperCol={24}
                                                                {...subfield}
                                                                name={[subfield?.name ?? '', 'form_column_selection_option_id']}
                                                                fieldKey={[subfield?.fieldKey ?? '', 'form_column_selection_option_id']}
                                                                label="form_column_selection_option_id"
                                                                hidden={true}
                                                            >
                                                            </Form.Item>
                                                        </Col>
                                                        <Col   >
                                                            <Form.Item
                                                                labelCol={24}
                                                                wrapperCol={24}
                                                                {...subfield}
                                                                name={[subfield?.name ?? '', 'selection_option_id']}
                                                                fieldKey={[subfield?.fieldKey ?? '', 'selection_option_id']}
                                                                label="selection_option_id"
                                                                hidden={true}
                                                            >
                                                            </Form.Item>
                                                        </Col>

                                                        <Col span={24} >
                                                            <Form.List
                                                                {...subfield}
                                                                name={[subfield?.name ?? '', 'selection_option_classify_structure_type_data']}
                                                            >
                                                                {(subsubfields, { add },) => (
                                                                    <Row>
                                                                        {subsubfields.map((subsubfield, subsubfieldsIndex) => (
                                                                            <Col span={24} key={subsubfield?.key}>
                                                                                <Row>
                                                                                    <Col >
                                                                                        <Form.Item
                                                                                            {...subsubfield}
                                                                                            labelCol={24}
                                                                                            wrapperCol={24}
                                                                                            name={[subsubfield?.name ?? '', 'selection_option_classify_structure_type_id']}
                                                                                            label="selection_option_classify_structure_type_id"
                                                                                            hidden={true}
                                                                                        >

                                                                                        </Form.Item>
                                                                                        <Form.Item
                                                                                            {...subsubfield}
                                                                                            labelCol={24}
                                                                                            wrapperCol={24}
                                                                                            name={[subsubfield?.name ?? '', 'classify_structure_type_id']}
                                                                                            label="classify_structure_type_id"
                                                                                            hidden={true}
                                                                                        >
                                                                                        </Form.Item>
                                                                                    </Col>
                                                                                    <Col span={24}>
                                                                                        <Row>
                                                                                            <Col span={24}>
                                                                                                <Form.List
                                                                                                    {...subsubfield}
                                                                                                    name={[subsubfield?.name, 'name_language_data']}>
                                                                                                    {(language_datafields, { add, }) => <>
                                                                                                        {language_datafields.map((language_datafield, index) => <>
                                                                                                            <Row gutter={[0, 0]}>
                                                                                                                <Col span={24}>
                                                                                                                    <Form.Item
                                                                                                                        {...language_datafield}
                                                                                                                        labelCol={24}
                                                                                                                        wrapperCol={24}
                                                                                                                        // label="語言代碼"
                                                                                                                        name={[language_datafield?.name || "", "language_manage_id"]}
                                                                                                                    // hidden={true}
                                                                                                                    >
                                                                                                                        {/* <Input /> */}
                                                                                                                    </Form.Item>
                                                                                                                </Col>
                                                                                                                <Col span={24}>
                                                                                                                    <Form.Item
                                                                                                                        {...language_datafield}
                                                                                                                        labelCol={24}
                                                                                                                        wrapperCol={24}
                                                                                                                        label="語言代碼"
                                                                                                                        name={[language_datafield?.name || "", "language_culture_code"]}
                                                                                                                        hidden={true}
                                                                                                                    >
                                                                                                                        <Input />
                                                                                                                    </Form.Item>
                                                                                                                </Col>
                                                                                                                <Col span={24}>
                                                                                                                    <div className="flex gap-2">
                                                                                                                        <Form.Item
                                                                                                                            {...language_datafield}
                                                                                                                            labelCol={24}
                                                                                                                            wrapperCol={24}
                                                                                                                            // label="選項文字"
                                                                                                                            name={[language_datafield?.name ?? '', 'language_culture_value']}
                                                                                                                            rules={[{ required: true, message: 'Please input folder name' }]}
                                                                                                                        >
                                                                                                                            <Input placeholder="選項文字" />
                                                                                                                        </Form.Item>
                                                                                                                        <Button onClick={() => {
                                                                                                                            removeFormColumnSelectionOptionData(subfieldIndex)
                                                                                                                        }}
                                                                                                                            variant="outline" size="sm">
                                                                                                                            刪除
                                                                                                                        </Button>
                                                                                                                    </div>
                                                                                                                </Col>
                                                                                                            </Row>
                                                                                                        </>)}
                                                                                                    </>}
                                                                                                </Form.List>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        ))}

                                                                    </Row>

                                                                )}
                                                            </Form.List>
                                                        </Col>
                                                    </Row>
                                                </Col>

                                            ))}
                                            <Col span={24}  >
                                                <Button
                                                    onClick={() => addFormColumnSelectionOptionData({ name: subfields })}
                                                    variant="outline" size="sm" className="w-full"
                                                    block
                                                >
                                                    + 新增選項
                                                </Button>
                                            </Col>
                                        </Row>
                                    )}
                                </Form.List>
                            </Col>
                        </>}

                        <Col span={24} >
                            <h5 className="font-medium text-gray-800">資料過濾條件設定</h5>
                        </Col>
                        <Col span={24} >
                            <ConditionBuilder
                                elementsData={elementsData}
                                form={form}
                                field={field}
                                documentData={documentController?.ResponseData}
                                selectedFields={form.getFieldValue([field?.name, 'selected_fields'])}
                            />
                        </Col>
                    </Row>
                </Col>
            </>}
        </Row>
    );
};





export default SettingToolForm;
const SpreadsheetData = ({
    name,
    value,
    onChange,
    onValueChange,
}) => {
    return <>
        <SpreadsheetEditor
            propsColumns={value?.columns}
            data={value?.data ?? []}
            onColumnsChange={(e) => {
                onChange({
                    target: {
                        name,
                        value: {
                            ...value,
                            columns: e
                        }
                    }
                });
                onValueChange({
                    target: {
                        name,
                        value: {
                            ...value,
                            columns: e
                        }
                    }
                });
            }}
            onChange={e => {
                onChange({
                    target: {
                        name,
                        value: {
                            ...value,
                            data: e
                        }
                    }
                });
                onValueChange({
                    target: {
                        name,
                        value: {
                            ...value,
                            data: e
                        }
                    }
                });
            }}
            xAxisField={value?.xAxis ?? "name"}
            yAxisField={value?.yAxis ?? "value"}
            onAxisChange={(xAxis, yAxis) => {

                onValueChange({
                    target: {
                        name,
                        value: {
                            ...value,
                            xAxis,
                            yAxis
                        }
                    }
                });
            }}
        />
    </>
}
const FiveWdocument = ({
    name,
    value,
    onChange,
    onValueChange,
    documentFiveWData = [],
    fiveWResponseAPI = "/utility/5w/document",
    setSelectDocumentAndResponseData = () => { },
    selectDocumentAndResponseData = []
}) => {
    const fiveWResponseController = useCRUDController({
        apiRoute: fiveWResponseAPI,
        onFinish: ({ axiosMode, status, values }) => {
            // if (axiosMode === "get" && status === "success") {
            //     onValueChange({
            //         target: {
            //             name,
            //             value: {
            //                 ...value,
            //                 data: values ?? [],
            //             }
            //         }
            //     })
            // }
        }
    })
    useEffect(() => {
        if (value && documentFiveWData) {

            fiveWResponseController.getData({ document_id: value })
                .then((res) => {
                    let responseData = res?.data || []
                    setSelectDocumentAndResponseData((pre) => {
                        let document_value = documentFiveWData?.find(_ => _.document_id === parseInt(value)) || {}
                        return [
                            {
                                document_data: [{ ...document_value }],
                                response_data: responseData
                            }
                        ]
                    })

                })
        }
    }, [value, documentFiveWData])
    return <>
        <DynamicDataSelector
            MOCK_TABLES={documentFiveWData
                ?.map(item => {
                    let document_form_data = item?.document_form_data || []
                    let form_form_column_data = document_form_data?.find(_ => true)?.form_form_column_data || []
                    let document_classify_structure_type_data = item?.document_classify_structure_type_data || []
                    let name_language_data = document_classify_structure_type_data?.find(_ => true)?.name_language_data || []
                    return ({
                        id: item?.document_id,
                        name: name_language_data?.find(_ => true)?.language_culture_value,
                        description: item?.document_description,
                        fields: form_form_column_data
                    })
                }) ?? []}
            selectedTable={value}
            onTableChange={e => {
                fiveWResponseController.getData({ document_id: e })
                    .then((res) => {
                        let responseData = res?.data || []
                        setSelectDocumentAndResponseData((pre) => {
                            let document_value = documentFiveWData?.find(_ => _.document_id === parseInt(e)) || {}
                            if (!!document_value) {
                                return [
                                    {
                                        document_data: [{ ...document_value }],
                                        response_data: responseData
                                    }
                                ]
                            }
                            else {
                                return []
                            }

                        })

                    })
                    .catch((error) => {
                        setSelectDocumentAndResponseData((pre) => {
                            let document_value = documentFiveWData?.find(_ => _.document_id === parseInt(e)) || {}
                            if (!!document_value) {
                                return [
                                    {
                                        document_data: [{ ...document_value }],
                                        response_data: []
                                    }
                                ]
                            }
                            else {
                                return []
                            }

                        })
                    })
                onValueChange({
                    target: {
                        name,
                        value: e
                    }
                })
            }}
        />
    </>
}
const FieldSelector = ({
    name,
    value,
    onChange,
    onValueChange,
    selectDocumentAndResponseData = []
}) => {
    const [availableFields, setAvailableFields] = useState([])

    useEffect(() => {
        if (selectDocumentAndResponseData?.length > 0) {
            const document_data = selectDocumentAndResponseData[0]?.document_data || []
            const document_form_data = document_data?.find(_ => true)?.document_form_data || []
            const form_form_column_data = document_form_data?.find(_ => true)?.form_form_column_data || []

            const fields = form_form_column_data.map(field => ({
                label: field.code,
                value: field.form_column_id,
                code: field.code
            }))
            setAvailableFields(fields)
        } else {
            setAvailableFields([])
        }
    }, [selectDocumentAndResponseData])

    if (availableFields.length === 0) {
        return <div className="text-sm text-gray-500">請先選擇資料來源</div>
    }

    return (
        <Select
            mode="multiple"
            placeholder="請選擇要顯示的欄位"
            options={availableFields}
            value={value}
            onChange={(selectedValues) => {
                onChange({
                    target: {
                        name,
                        value: selectedValues
                    }
                })
                onValueChange?.({
                    target: {
                        name,
                        value: selectedValues
                    }
                })
            }}
        />
    )
}
const ChartDataSetting = ({
    name,
    value,
    onChange,
    onValueChange,
    setSelectDocumentAndResponseData,
    selectDocumentAndResponseData
}) => {
    const [columns, setColumns] = useState([])
    const [data, setData] = useState([])

    const getColumnsAndData = (selectDocumentAndResponseData) => {
        let columns = []
        let data = []
        if (selectDocumentAndResponseData?.length > 0) {
            selectDocumentAndResponseData.forEach((ele) => {
                let responseData = ele?.response_data || []
                let document_data = ele?.document_data || []
                let document_form_data = document_data?.find(_ => true)?.document_form_data || []
                let form_form_column_data = document_form_data?.find(_ => true)?.form_form_column_data || []
                let form_form_column_data_codes = form_form_column_data?.map(_ => _.code) || []
                //產生columns
                columns = Array.from(new Set([...columns, ...form_form_column_data_codes]))
                //產生Data
                data = transformResponses(responseData, columns)

            })
        }
        onChange({
            target: {
                name,
                value: {
                    ...value,
                    columns: columns
                }
            }
        });
        onValueChange({
            target: {
                name,
                value: {
                    ...value,
                    columns: columns
                }
            }
        });

        return { columns, data }
    }


    useEffect(() => {
        let nawSetting = getColumnsAndData(selectDocumentAndResponseData)
        setData(nawSetting.data || [])
        setColumns(nawSetting.columns || [])
    }, [selectDocumentAndResponseData])
    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <SpreadsheetEditor
                    readOnly={true}
                    propsColumns={columns}
                    data={data ?? []}

                    onChange={e => {

                        onChange({
                            target: {
                                name,
                                value: {
                                    ...value,
                                    data: e
                                }
                            }
                        });
                        onValueChange({
                            target: {
                                name,
                                value: {
                                    ...value,
                                    data: e
                                }
                            }
                        });
                    }}
                    xAxisField={value?.xAxis ?? "name"}
                    yAxisField={value?.yAxis ?? "value"}
                    onAxisChange={(xAxis, yAxis) => {
                        onValueChange({
                            target: {
                                name,
                                value: {
                                    ...value,
                                    xAxis,
                                    yAxis
                                }
                            }
                        });
                    }}
                />
            </Col>
        </Row>
    )
}
const ConditionBuilder = ({
    form,
    field,
    elementsData = [],
    documentData = []
}) => {
    const getFormColumnOptions = (document_id) => {
        if (document_id === undefined) return []
        let options = []

        let document = documentData?.find(_ => _.document_id === parseInt(document_id)) || {}
        let document_classify_structure_type_data = document?.document_classify_structure_type_data || []
        let document_classify_structure_type_data_first = document_classify_structure_type_data?.find(_ => true) || {}
        let document_form_data = document_classify_structure_type_data_first?.document_form_data || []
        let form_form_column_data = document_form_data?.find(_ => true)?.form_form_column_data || []
        options = form_form_column_data?.filter((ele) => !!ele?.code)?.map((col) => ({
            label: col?.code,
            value: col?.code,
        }))
        return options
    }
    return (
        <div className="space-y-1">
            <div className=" border rounded bg-gray-50"  >
                <Row gutter={[8, 8]}>
                    <Col span={24} >
                        <Form.List
                            {...field}
                            name={[field?.name, 'form_column_filter_data']}>
                            {(subfields, { add, remove }) => <Row gutter={[8, 8]}>

                                {subfields.map((subfield, index) => <Col span={24}>
                                    <Row gutter={[0, 0]}>
                                        {(!(index !== 0)) && <Col span={12}>
                                            <Form.List
                                                {...subfield}
                                                name={[subfield?.name, 'filter_document_data']}
                                                hidden={index !== 0}
                                            >
                                                {(subfields, { add, remove }) => {
                                                    return (<Row>
                                                        {subfields.map((subfield, subfieldIndex) => (
                                                            <Col span={24} key={subfield?.key}>
                                                                <Form.Item
                                                                    labelCol={24}
                                                                    wrapperCol={24}
                                                                    name={[subfield?.name ?? '', 'document_id']}
                                                                    label={'來源資料表單'}
                                                                    hidden={index !== 0}
                                                                >
                                                                    <Select
                                                                        placeholder="來源資料"
                                                                        options={documentData?.map(item => (
                                                                            {
                                                                                label: item?.document_name,
                                                                                value: item?.document_id,
                                                                            }
                                                                        ))}
                                                                    />
                                                                </Form.Item>
                                                            </Col>))}
                                                    </Row>)
                                                }}
                                            </Form.List>
                                        </Col>}

                                        {(!(index === 0)) && <Col span={12}>
                                            <Form.Item
                                                {...subfield}
                                                labelCol={24}
                                                wrapperCol={24}
                                                name={[subfield?.name ?? '', 'logic']}
                                                label={"邏輯"}
                                                hidden={index === 0}
                                            >
                                                <Select
                                                    placeholder="邏輯"
                                                    options={
                                                        [
                                                            {
                                                                label: '(且)AND',
                                                                value: "AND"
                                                            },
                                                            {
                                                                label: '(或)OR',
                                                                value: "OR"
                                                            },
                                                        ]

                                                    }
                                                    className="w-full"
                                                />
                                            </Form.Item>
                                        </Col>}
                                        <Col span={12}>
                                            <Form.Item
                                                {...subfield}
                                                labelCol={24}
                                                wrapperCol={24}
                                                name={[subfield?.name ?? '', 'code']}
                                                label={"過濾欄位項目"}
                                            >
                                                <Select
                                                    placeholder="選擇欄位"
                                                    options={
                                                        getFormColumnOptions(form.getFieldValue(['form_column_filter_data.0.filter_document_data.0', 'document_id']))
                                                    }
                                                    className="w-full"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                {...subfield}
                                                labelCol={24}
                                                wrapperCol={24}
                                                name={[subfield?.name ?? '', 'code_major']}
                                                label={"欄位"}
                                            >
                                                <Select
                                                    options={
                                                        getFormColumnOptions(form.getFieldValue(['form_column_filter_data.0.filter_document_data.0', 'document_id']))
                                                    }
                                                    className="w-full"
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={12}>
                                            <Form.Item
                                                {...subfield}
                                                labelCol={24}
                                                wrapperCol={24}
                                                name={[subfield?.name ?? '', 'condition']}
                                                label={"判斷符"}
                                            >
                                                <Select
                                                    placeholder="判斷符"
                                                    options={[
                                                        {
                                                            label: '等於',
                                                            value: '等於'
                                                        },
                                                        {
                                                            label: "不等於",
                                                            value: "不等於"
                                                        },
                                                        {
                                                            label: "包含",
                                                            value: "包含"
                                                        },
                                                        {
                                                            label: "不包含",
                                                            value: "不包含"
                                                        },
                                                        {
                                                            label: "大於",
                                                            value: "大於"
                                                        },
                                                        {
                                                            label: "小於",
                                                            value: "小於"
                                                        },
                                                        {
                                                            label: "大於等於",
                                                            value: "大於等於"
                                                        },
                                                        {
                                                            label: "小於等於",
                                                            value: "小於等於"
                                                        },
                                                    ]}
                                                    className="w-full"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                {...subfield}
                                                labelCol={24}
                                                wrapperCol={24}
                                                name={[subfield?.name ?? '', 'value_type']}
                                                label={"值類型"}
                                            >
                                                <Radio.Group
                                                // direction='horizontal'
                                                >
                                                    <Radio
                                                        value="固定值"
                                                    // onChange={() => handleTypeChange('fixed')}
                                                    >
                                                        固定值
                                                    </Radio>
                                                    <Radio
                                                        value="欄位參考"
                                                    // onChange={() => handleTypeChange('field_ref')}
                                                    >
                                                        欄位參考
                                                    </Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>
                                        {form.getFieldValue([subfield?.name, "value_type"]) === "欄位參考" ?
                                            <Col span={12}>
                                                <Form.Item
                                                    {...subfield}
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    name={[subfield?.name ?? '', 'code_minor']}
                                                    label={"欄位參考"}
                                                >
                                                    <Select
                                                        placeholder="欄位參考"
                                                        options={elementsData
                                                            ?.filter((ele) => {
                                                                let form_form_column_data = ele?.form_form_column_data || []
                                                                let form_form_column_data_first = form_form_column_data?.find(_ => true) || {}
                                                                let code = form_form_column_data_first?.code
                                                                let elementCode = form.getFieldValue([field?.name, 'code'])
                                                                return !!code && elementCode !== code
                                                            })
                                                            ?.map((ele) => {
                                                                let form_form_column_data = ele?.form_form_column_data || []
                                                                let form_form_column_data_first = form_form_column_data?.find(_ => true) || {}
                                                                let code = form_form_column_data_first?.code
                                                                return (
                                                                    {
                                                                        label: code,
                                                                        value: code
                                                                    }
                                                                )
                                                            })
                                                        }
                                                        className="w-full"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            :
                                            <Col span={12}>
                                                <Form.Item
                                                    {...subfield}
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    name={[subfield?.name ?? '', 'value.value']}
                                                    label={"固定值"}
                                                >
                                                    <Input
                                                        placeholder="固定值"
                                                        className="w-full"
                                                    />
                                                </Form.Item>
                                            </Col>
                                        }
                                        <Col span={24}>
                                            <Button
                                                type={'danger'}
                                                onClick={() => {
                                                    remove(index)
                                                }}>
                                                刪除
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>)}
                                <Col span={24}
                                >
                                    <Button
                                        onClick={() => {
                                            let document_id = form.getFieldValue(['form_column_filter_data.0.filter_document_data.0', 'document_id']) || null
                                            add({
                                                condition: "等於",
                                                code: "1",
                                                code_major: "2",
                                                code_minor: "3",
                                                value_type: "固定值",
                                                value: { "value": 1 },
                                                logic: "AND",
                                                filter_document_data: [{ "document_id": document_id }]
                                            })
                                        }}>
                                        新增條件
                                    </Button>
                                </Col>
                            </Row>}
                        </Form.List>
                    </Col>

                </Row>

            </div>




        </div>
    )
}
const DefaultValueSelector = ({
    form,
    field,
    elementsData = [],
    documentData = []
}) => {

    const getFormColumnOptions = (document_id) => {
        if (document_id === undefined) return []
        let options = []

        let document = documentData?.find(_ => _.document_id === parseInt(document_id)) || {}
        let document_classify_structure_type_data = document?.document_classify_structure_type_data || []
        let document_classify_structure_type_data_first = document_classify_structure_type_data?.find(_ => true) || {}
        let document_form_data = document_classify_structure_type_data_first?.document_form_data || []
        let form_form_column_data = document_form_data?.find(_ => true)?.form_form_column_data || []
        options = form_form_column_data?.filter((ele) => !!ele?.code)?.map((col) => ({
            label: col?.code,
            value: col?.code,
        }))
        return options
    }
    return (
        <div className="space-y-3 bg-gray-50 p-3 rounded">
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
                <Form.Item
                    {...field}
                    labelCol={24}
                    wrapperCol={24}
                    name={[field?.name ?? '', 'default_value_type']}
                    label={"預設值"}
                >
                    <Radio.Group
                        direction='horizontal'
                    >
                         <Radio
                            value="無"
                        >
                            無
                        </Radio>
                        <Radio
                            value="無"
                        >
                            無
                        </Radio>
                        <Radio
                            value="固定值"
                        >
                            固定值
                        </Radio>
                        <Radio
                            value="欄位參考"
                        >
                            欄位參考
                        </Radio>
                        <Radio
                            value="欄位引用"
                            onClick={() => {
                                form.setFieldValue(field?.name ? ([field?.name, 'form_column_calculate_data']).join(',') : 'form_column_calculate_data', [{
                                    value_type_major: "欄位引用",
                                    code_major: "",
                                    value_major: 1,
                                    operation: "加",
                                    value_type_minor: "固定值",
                                    code_minor: "",
                                    value_minor: 1,
                                }])
                            }}
                        >
                            欄位引用
                        </Radio>
                        <Radio
                            value="欄位帶入"
                            onClick={() => {
                                form.setFieldValue(field?.name ? ([field?.name, 'form_column_calculate_data']).join(',') : 'form_column_calculate_data', [{
                                    value_type_major: "欄位帶入",
                                    code_major: "",
                                    value_major: 1,
                                    operation: "加",
                                    value_type_minor: "欄位帶入",
                                    code_minor: "",
                                    value_minor: 1,
                                }])
                            }}
                        >
                            欄位帶入
                        </Radio>
                    </Radio.Group>
                </Form.Item>
            </div>

            {form.getFieldValue([field?.name, 'default_value_type']) === '固定值' &&
                <Form.Item
                    {...field}
                    labelCol={24}
                    wrapperCol={24}
                    name={[field?.name ?? '', 'default_value']}
                >
                    <Input
                        placeholder="輸入固定預設值"
                        className="w-full"
                    />
                </Form.Item>
            }

            {form.getFieldValue([field?.name, 'default_value_type']) === '欄位參考' &&
                <div className="space-y-3">
                    <div className="border-t ">
                        <h6 className="text-sm font-medium mb-2">公式計算</h6>
                        <Form.List
                            {...field}
                            name={[field?.name, 'form_column_calculate_data']}>
                            {(subfields, { add, remove }) => <Row>
                                {subfields?.length === 0 && <Col span={24}
                                >
                                    <Button
                                        onClick={() => add({
                                            value_type_major: "欄位參考",
                                            code_major: "",
                                            value_major: 1,
                                            operation: "加",
                                            value_type_minor: "固定值",
                                            code_minor: "",
                                            value_minor: 1,
                                        })}>
                                        新增計算項目
                                    </Button>
                                </Col>}
                                {subfields.map((subfield, index) => <Col span={24}>
                                    <Row gutter={[0, 0]}>
                                        <Col span={24}>
                                            <Form.Item
                                                {...subfield}
                                                labelCol={24}
                                                wrapperCol={24}
                                                name={[subfield?.name ?? '', 'value_type_major']}
                                                label={"值類型"}
                                            >
                                                <Radio.Group
                                                    direction='horizontal'
                                                >
                                                    <Radio
                                                        value="固定值"
                                                    // onChange={() => handleTypeChange('fixed')}
                                                    >
                                                        固定值
                                                    </Radio>
                                                    <Radio
                                                        value="欄位參考"
                                                    // onChange={() => handleTypeChange('field_ref')}
                                                    >
                                                        欄位參考
                                                    </Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>
                                        {form.getFieldValue([subfield?.name, "value_type_major"]) === "欄位參考" ?
                                            <Col span={24}>
                                                <Form.Item
                                                    {...subfield}
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    name={[subfield?.name ?? '', 'code_major']}
                                                    label={"欄位"}
                                                >
                                                    <Select
                                                        options={elementsData
                                                            ?.filter((ele) => {
                                                                let form_form_column_data = ele?.form_form_column_data || []
                                                                let form_form_column_data_first = form_form_column_data?.find(_ => true) || {}
                                                                let code = form_form_column_data_first?.code
                                                                let elementCode = form.getFieldValue([field?.name, 'code'])
                                                                return !!code && elementCode !== code
                                                            })
                                                            ?.map((ele) => {
                                                                let form_form_column_data = ele?.form_form_column_data || []
                                                                let form_form_column_data_first = form_form_column_data?.find(_ => true) || {}
                                                                let code = form_form_column_data_first?.code
                                                                return (
                                                                    {
                                                                        label: code,
                                                                        value: code
                                                                    }
                                                                )
                                                            })
                                                        }
                                                        className="w-full"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            :
                                            <Col span={24}>
                                                <Form.Item
                                                    {...subfield}
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    name={[subfield?.name ?? '', 'value_major']}
                                                    label={"固定值"}
                                                >
                                                    <Input
                                                        type="number"
                                                        placeholder="固定值"
                                                        className="w-full"
                                                    />
                                                </Form.Item>
                                            </Col>
                                        }
                                        <Col span={24}>
                                            <Form.Item
                                                {...subfield}
                                                labelCol={24}
                                                wrapperCol={24}
                                                name={[subfield?.name ?? '', 'operation']}
                                                label={"運算式"}
                                            >
                                                <Select
                                                    placeholder="運算式"
                                                    options={[
                                                        {
                                                            label: '+',
                                                            value: '加'
                                                        },
                                                        {
                                                            label: "-",
                                                            value: "減"
                                                        },
                                                        {
                                                            label: "×",
                                                            value: "乘"
                                                        },
                                                        {
                                                            label: "÷",
                                                            value: "除"
                                                        }

                                                    ]}
                                                    className="w-full"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...subfield}
                                                labelCol={24}
                                                wrapperCol={24}
                                                name={[subfield?.name ?? '', 'value_type_minor']}
                                                label={"值類型"}
                                            >
                                                <Radio.Group
                                                    direction='horizontal'
                                                >
                                                    <Radio
                                                        value="固定值"
                                                    // onChange={() => handleTypeChange('fixed')}
                                                    >
                                                        固定值
                                                    </Radio>
                                                    <Radio
                                                        value="欄位參考"
                                                    // onChange={() => handleTypeChange('field_ref')}
                                                    >
                                                        欄位參考
                                                    </Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>
                                        {form.getFieldValue([subfield?.name, "value_type_minor"]) === "欄位參考" ?
                                            <Col span={24}>
                                                <Form.Item
                                                    {...subfield}
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    name={[subfield?.name ?? '', 'code_minor']}
                                                    label={"欄位參考"}
                                                >
                                                    <Select
                                                        placeholder="欄位參考"
                                                        options={elementsData
                                                            ?.filter((ele) => {
                                                                let form_form_column_data = ele?.form_form_column_data || []
                                                                let form_form_column_data_first = form_form_column_data?.find(_ => true) || {}
                                                                let code = form_form_column_data_first?.code
                                                                let elementCode = form.getFieldValue([field?.name, 'code'])
                                                                return !!code && elementCode !== code
                                                            })
                                                            ?.map((ele) => {
                                                                let form_form_column_data = ele?.form_form_column_data || []
                                                                let form_form_column_data_first = form_form_column_data?.find(_ => true) || {}
                                                                let code = form_form_column_data_first?.code
                                                                return (
                                                                    {
                                                                        label: code,
                                                                        value: code
                                                                    }
                                                                )
                                                            })
                                                        }
                                                        className="w-full"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            :
                                            <Col span={24}>
                                                <Form.Item
                                                    {...subfield}
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    name={[subfield?.name ?? '', 'value_minor']}
                                                    label={"固定值"}
                                                >
                                                    <Input
                                                        type="text"
                                                        placeholder="固定值"
                                                        className="w-full"
                                                    />
                                                </Form.Item>
                                            </Col>
                                        }
                                    </Row>
                                </Col>)}
                            </Row>}
                        </Form.List>
                    </div>
                </div>}
            {form.getFieldValue([field?.name, 'default_value_type']) === '欄位引用' && <div className="space-y-3">
                <div className="border-t ">
                    <Row gutter={[0, 0]}>
                        <Col span={24}>
                            <Form.Item
                                {...field}
                                labelCol={24}
                                wrapperCol={24}
                                name={[field?.name, 'form_column_calculate_data', '0', 'code_major']}
                                label={"欄位"}
                            >
                                <Select
                                    options={elementsData
                                        ?.filter((ele) => {
                                            let form_form_column_data = ele?.form_form_column_data || []
                                            let form_form_column_data_first = form_form_column_data?.find(_ => true) || {}
                                            let code = form_form_column_data_first?.code
                                            let elementCode = form.getFieldValue([field?.name, 'code'])
                                            return !!code && elementCode !== code
                                        })
                                        ?.map((ele) => {
                                            let form_form_column_data = ele?.form_form_column_data || []
                                            let form_form_column_data_first = form_form_column_data?.find(_ => true) || {}
                                            let code = form_form_column_data_first?.code
                                            return (
                                                {
                                                    label: code,
                                                    value: code
                                                }
                                            )
                                        })
                                    }
                                    className="w-full"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
            </div>}

            {form.getFieldValue([field?.name, 'default_value_type']) === '欄位帶入' && <div className="space-y-3">
                <div className="border-t ">
                    <Row gutter={[0, 0]}>
                        <Col span={24}>
                            <Form.List
                                {...field}
                                name={[field?.name, 'form_column_calculate_data']}
                            >
                                {(subfields, { add, remove }) => {
                                    return (<Row>
                                        {subfields.map((subfield, subfieldIndex) => (<>
                                            <Col span={24}>
                                                <Form.Item
                                                    {...field}
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    name={[subfield?.name ?? '', 'code_major']}
                                                    label={"帶入欄位項目"}
                                                >
                                                    <Select
                                                        placeholder="欄位參考"
                                                        options={elementsData
                                                            ?.filter((ele) => {
                                                                let form_form_column_data = ele?.form_form_column_data || []
                                                                let form_form_column_data_first = form_form_column_data?.find(_ => true) || {}
                                                                let code = form_form_column_data_first?.code
                                                                let elementCode = form.getFieldValue([field?.name, 'code'])
                                                                return !!code && elementCode !== code
                                                            })
                                                            ?.map((ele) => {
                                                                let form_form_column_data = ele?.form_form_column_data || []
                                                                let form_form_column_data_first = form_form_column_data?.find(_ => true) || {}
                                                                let code = form_form_column_data_first?.code
                                                                return (
                                                                    {
                                                                        label: code,
                                                                        value: code
                                                                    }
                                                                )
                                                            })
                                                        }
                                                        className="w-full"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12} key={subfield?.key}>
                                                <Form.Item
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    name={[subfield?.name ?? '', 'calculate_document_data.0.document_id']}
                                                    label={'來源資料表單'}
                                                >
                                                    <Select
                                                        placeholder="來源資料"
                                                        options={documentData?.map(item => (
                                                            {
                                                                label: item?.document_name,
                                                                value: item?.document_id,
                                                            }
                                                        ))}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    {...field}
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    name={[subfield?.name ?? '', 'code_minor']}
                                                    label={"來源欄位項目"}
                                                >
                                                    <Select
                                                        placeholder="選擇欄位"
                                                        options={
                                                            getFormColumnOptions(form.getFieldValue(['form_column_calculate_data.0.calculate_document_data.0', 'document_id']))
                                                        }
                                                        className="w-full"
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </>))}
                                    </Row>)
                                }}
                            </Form.List>
                        </Col>
                    </Row>
                </div>
            </div>}
        </div>
    )
}